import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { FaqPageBody } from "../components/FaqPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.FaqPageTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <FaqPageBody page={props.page} side_nav={props.side_nav} />
        </PageSkeleton>
    );
};
